var host = window.location.hostname;
//var baseUrl = "https://apidevmid19.pbmg.com.mx:3000";
var baseUrl = 'http://apipayroll.dv:3000';
//var baseUrl = "http://api.gdth.dv:3000";

function getHost() {
  if (host === "gdth.cliker.com.mx" || host === "www.gdth.cliker.com.mx") {
    baseUrl = "https://gdth.cliker.com.mx:3000";
  } else if (
    host === "mid20dev.pbmg.com.mx" ||
    host === "www.mid20dev.pbmg.com.mx"
  ) {
    baseUrl = "https://devmid19.pbmg.com.mx:3000";
  }

  return baseUrl;
}

const SocketService = {
  getHost,
};

export default SocketService;
